<template lang="pug">
div
  section.callout__404
    .intro__404
      h1.intro__404--mobile Oops! This page is lost in the woods.
      h1.intro__404--desktop Oops! This page is lost in the wild.
      a(href="/")
        button.btn.btn--white Go home

  section.full__video.full__video--404#fluid__404
    .fluid__video.splash--404.fluid__video_404
      .fluid__video_404--mobile
        iframe(data-src='https://media.flixel.com/cinemagraph/02wesokj9lcphjnob2ba?hd=true' allow='autoplay')
      .fluid__video_404--desktop
        iframe(data-src='https://media.flixel.com/cinemagraph/9m3xdkl8nmv3uibgwitm?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/ixhumni/') Alexandre Miguel
</template>

<script>
export default {
  name: 'PageNotFound',
  metaInfo() {
    return {
      // Prerender 404
      'property': 'prerender-status-code',
      'code': 404,
    };
  },
  mounted() {
    let windowWidth = window.innerWidth / 2;
    const height404Max = document.getElementById('fluid__404');
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
    if (window.innerWidth >= 768) {
      height404Max.style.maxHeight = windowWidth + 'px';
    } else {
      height404Max.style.maxHeight = '400px';
    }

    $(window).resize(function () {
      windowWidth = (window.innerWidth/2);
      if (window.innerWidth >= 768) {
        height404Max.style.maxHeight = windowWidth + 'px';
      } else {
        height404Max.style.maxHeight = '400px';
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/views/404.vue